import { Routes, Route } from 'react-router-dom';
import { useNavigate} from 'react-router-dom';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Test from './Test';

function Glavn()
{
 const navigate = useNavigate();
  const handleClick = () => {
   navigate('/test');
  };
    
  return (
  <div className="Glavn">
  <div className="catalog">
    
    {/* Ряд 1 */}
    <div className="row">
      <Link to="/intj"><iframe src="https://assets.pinterest.com/ext/embed.html?id=222787512813170203" height="200" width="200" frameBorder="0" scrolling="no" style={{ display: 'block', pointerEvents: 'none' }} /></Link>
      <Link to="/intp"><iframe src="https://assets.pinterest.com/ext/embed.html?id=336573772176622129" height="200" width="200" frameBorder="0" scrolling="no" style={{ display: 'block', pointerEvents: 'none' }} /></Link>
      <Link to="/entj"><iframe src="https://assets.pinterest.com/ext/embed.html?id=890516526377789565" height="200" width="200" frameBorder="0" scrolling="no" style={{ display: 'block', pointerEvents: 'none' }} /></Link>
      <Link to="/entp"><iframe src="https://assets.pinterest.com/ext/embed.html?id=44754590043662163" height="200" width="200" frameBorder="0" scrolling="no" style={{ display: 'block', pointerEvents: 'none' }} /></Link>
    </div>

    {/* Ряд 2 */}
    <div className="row">
      <Link to="/istj"><iframe src="https://assets.pinterest.com/ext/embed.html?id=92886811061452717" height="200" width="200" frameBorder="0" scrolling="no" style={{ display: 'block', pointerEvents: 'none' }} /></Link>
      <Link to="/estj"><iframe src="https://assets.pinterest.com/ext/embed.html?id=782430135277117052" height="200" width="200" frameBorder="0" scrolling="no" style={{ display: 'block', pointerEvents: 'none' }} /></Link>
      <Link to="/isfj"><iframe src="https://assets.pinterest.com/ext/embed.html?id=717339046923863191" height="200" width="200" frameBorder="0" scrolling="no" style={{ display: 'block', pointerEvents: 'none' }} /></Link>
      <Link to="/esfj"><iframe src="https://assets.pinterest.com/ext/embed.html?id=1142014418039810962" height="200" width="200" frameBorder="0" scrolling="no" style={{ display: 'block', pointerEvents: 'none' }} /></Link>
    </div>

    {/* Ряд 3 */}
    <div className="row">
      <Link to="/isfp"><iframe src="https://assets.pinterest.com/ext/embed.html?id=50384089577283148" height="200" width="200" frameBorder="0" scrolling="no" style={{ display: 'block', pointerEvents: 'none' }} /></Link>
      <Link to="/istp"><iframe src="https://assets.pinterest.com/ext/embed.html?id=918101074055324175" height="200" width="200" frameBorder="0" scrolling="no" style={{ display: 'block', pointerEvents: 'none' }} /></Link>
      <Link to="/esfp"><iframe src="https://assets.pinterest.com/ext/embed.html?id=97671885661923573" height="200" width="200" frameBorder="0" scrolling="no" style={{ display: 'block', pointerEvents: 'none' }} /></Link>
      <Link to="/estp"><iframe src="https://assets.pinterest.com/ext/embed.html?id=764063893076596786" height="200" width="200" frameBorder="0" scrolling="no" style={{ display: 'block', pointerEvents: 'none' }} /></Link>
    </div>

    {/* Ряд 4 */}
    <div className="row">
      <Link to="/infj"><iframe src="https://assets.pinterest.com/ext/embed.html?id=233835405656746903" height="200" width="200" frameBorder="0" scrolling="no" style={{ display: 'block', pointerEvents: 'none' }} /></Link>
      <Link to="/infp"><iframe src="https://assets.pinterest.com/ext/embed.html?id=84653668203885964" height="200" width="200" frameBorder="0" scrolling="no" style={{ display: 'block', pointerEvents: 'none' }} /></Link>
      <Link to="/enfp"><iframe src="https://assets.pinterest.com/ext/embed.html?id=301459768827579735" height="200" width="200" frameBorder="0" scrolling="no" style={{ display: 'block', pointerEvents: 'none' }} /></Link>
      <Link to="/enfj"><iframe src="https://assets.pinterest.com/ext/embed.html?id=923378729872462750" height="200" width="200" frameBorder="0" scrolling="no" style={{ display: 'block', pointerEvents: 'none' }} /></Link>
    </div>

    <div className="catalog-footer">
      <Link to="/test">
        <button className="catalog-btn">Пройти тест</button>
      </Link>
    </div>

  </div>
</div>
  );
}
export default Glavn;